import {isDesktopNavigation} from '../helper/media-queries';
import {
	addCallback,
	addClassToList,
	removeClass,
	toggle
} from './backdrop';

const backdropClass = 'nav-big-active';

let navTrigger: HTMLElement;
let navBody: HTMLElement;
let primaryMenus: NodeListOf<HTMLElement>;
let activeNavBody: HTMLDivElement;
let activeNavTrigger: HTMLAnchorElement;

export function initNavigation() {
	initBackdrop();
	initHamburgerToggle();
	initFlyoutToggle();
	initPrimaryMenu();
}

function initBackdrop() {
	addClassToList(backdropClass);
	addCallback(resetHamburger);
	addCallback(resetFlyout);
}

function initHamburgerToggle() {
	navTrigger = document.querySelector('.action__trigger--toggle');
	navBody = document.querySelector('.action__body');

	if (!navTrigger || !navBody) return false;

	navTrigger.addEventListener('click', () => {
		navTrigger.classList.toggle('is-open');
		navBody.classList.toggle('is-active');
		toggle(backdropClass);
	});

	window.addEventListener('resize', () => {
		if (!isDesktopNavigation()) {
			navTrigger.classList.remove('is-open');
			navTrigger.nextElementSibling.classList.remove('is-active');
			removeClass(backdropClass);
		}
	});
}

function resetHamburger() {
	if (navBody) {
		navTrigger.classList.remove('is-open');
		navBody.classList.remove('is-active');
	}
}

function initFlyoutToggle() {
	const nav: HTMLDivElement = document.querySelector('.nav-big');
	if (!nav) return false;

	const triggers: NodeListOf<HTMLAnchorElement> = nav.querySelectorAll('.nav-big__trigger');
	if (!nav || !triggers) return false;

	for (let i = 0, triggersCount = triggers.length; i < triggersCount; i++) {
		if (triggers[i].nextElementSibling !== null &&
			triggers[i].nextElementSibling.classList.contains('nav-big__body')) {
			triggers[i].addEventListener('click', onNavTriggerClick);
		}
	}
}

function initPrimaryMenu() {
	primaryMenus = document.querySelectorAll('.primary-menu');

	if (!primaryMenus || !primaryMenus.length) return false;

	Array.prototype.forEach.call(primaryMenus, (primaryMenu: HTMLElement) => {
		const primaryMenuWrapper: HTMLElement = primaryMenu.parentElement;
		const nextButtons: NodeListOf<HTMLElement> = primaryMenu.querySelectorAll('.primary-menu__item--next');
		const backButtons: NodeListOf<HTMLElement> = primaryMenu.querySelectorAll('.primary-menu__item--back');

		if (!primaryMenuWrapper || !nextButtons || !backButtons) return false;

		Array.prototype.forEach.call(nextButtons, (nextButton: HTMLElement) => {
			nextButton.addEventListener('click', (e: MouseEvent) => {
				goToNextLevel(e, primaryMenu, primaryMenuWrapper);
			});
		});

		Array.prototype.forEach.call(backButtons, (backButton: HTMLElement) => {
			backButton.addEventListener('click', (e: MouseEvent) => {
				goToPreviousLevel(e, primaryMenu, primaryMenuWrapper);
			});
		});
	});
}

function onNavTriggerClick(e: MouseEvent) {
	e.preventDefault();
	e.stopPropagation();

	const navTrigger: HTMLAnchorElement = e.target as HTMLAnchorElement;

	if (!activeNavBody) {
		showNavBody(navTrigger);
		toggle(backdropClass);
	} else if (activeNavBody === navTrigger.nextElementSibling) {
		hideNavBody();
		toggle(backdropClass);
	} else {
		hideNavBody();
		showNavBody(navTrigger);
	}

	return false;
}

function showNavBody(navTrigger: HTMLAnchorElement) {
	activeNavTrigger = navTrigger;
	activeNavTrigger.classList.add('is-triggered');
	activeNavBody = activeNavTrigger.nextElementSibling as HTMLDivElement;
	activeNavBody.classList.add('is-active');
}

function hideNavBody() {
	activeNavTrigger.classList.remove('is-triggered');
	activeNavBody.classList.remove('is-active');
	activeNavBody = null;
}

function resetFlyout() {
	if (activeNavBody) {
		hideNavBody();
		activeNavTrigger = null;
	}
}

function goToNextLevel(e: MouseEvent, primaryMenu: HTMLElement, primaryMenuWrapper: HTMLElement) {
	e.preventDefault();

	const nextButton: HTMLElement = e.currentTarget as HTMLElement;
	const activeContainer: HTMLElement = primaryMenu.querySelector('.primary-menu__container.is-active');
	const nextContainer: HTMLElement = nextButton.nextElementSibling as HTMLElement;

	// set active container
	activeContainer.classList.remove('is-active');
	nextContainer.classList.add('is-active');

	// set new menu height
	primaryMenuWrapper.style.height = nextContainer.getBoundingClientRect().height + 'px';

	scrollUp(primaryMenu);
	increaseLevel(primaryMenu);
}

function goToPreviousLevel(e: MouseEvent, primaryMenu: HTMLElement, primaryMenuWrapper: HTMLElement) {
	e.preventDefault();

	const activeContainer: HTMLElement = primaryMenu.querySelector('.primary-menu__container.is-active');
	const previousContainer: HTMLElement = activeContainer.parentElement.closest('.primary-menu__container') as HTMLElement;

	// set active container
	activeContainer.classList.remove('is-active');
	previousContainer.classList.add('is-active');

	// set new menu height
	primaryMenuWrapper.style.height = previousContainer.getBoundingClientRect().height + 'px';

	scrollUp(primaryMenu);
	decreaseLevel(primaryMenu);
}

function increaseLevel(primaryMenu: HTMLElement) {
	const levelClass = primaryMenu.getAttribute('class');
	const levelClassIndex = levelClass.indexOf('level-');

	if (levelClassIndex < 0) {
		primaryMenu.classList.add('level-1');
		return;
	}

	const level = levelClass.charAt(levelClassIndex + 6);

	primaryMenu.classList.remove('level-' + level);
	primaryMenu.classList.add('level-' + (parseInt(level) + 1));
}

function decreaseLevel(primaryMenu: HTMLElement) {
	const levelClass = primaryMenu.getAttribute('class');
	const levelClassIndex = levelClass.indexOf('level-');

	if (primaryMenu.classList.contains('level-1')) {
		primaryMenu.classList.remove('level-1');
		return;
	}

	const level = levelClass.charAt(levelClassIndex + 6);

	primaryMenu.classList.remove('level-' + level);
	primaryMenu.classList.add('level-' + (parseInt(level) - 1));
}

function scrollUp(primaryMenu: HTMLElement) {
	if (!isDesktopNavigation()) {
		const actionBody: HTMLElement = primaryMenu.closest('.action__body.is-active') as HTMLElement;

		if (actionBody) {
			actionBody.scrollTop = 0;
		}
	}
}
